export default "__VITE_ASSET__036d9c34__"